/**
 * Maximum image upload size in megabytes.
 * Keep in sync with apps/backend/src/constants/upload.ts and Fastify bodyLimit.
 */
export const MAX_UPLOAD_SIZE_MB = 5;
export const MAX_UPLOAD_SIZE_BYTES = MAX_UPLOAD_SIZE_MB * 1024 * 1024;
